import React from "react"
import classNames from "classnames"

import styles from "./index.module.less"

const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (
    props
) => {
    const { className, ...rest } = props
    return <input className={classNames(styles.input, className)} {...rest} />
}
export default Input
